import PropTypes from "prop-types";
import { Component } from "react";
import { OFFER_TYPES } from "app/constants";
import Radio from "app/pages/.shared/form/Radio.jsx";
import Button from "app/pages/.shared/form/Button";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import { FormattedMessage, FormattedPlural } from "react-intl";
import get from "lodash/get";
import FrequencyFlyersMarketing from "@brand/FrequencyFlyersMarketing/FrequencyFlyersMarketing";
import TransportationPictoContainer from "app/pages/.shared/TransportationPicto/TransportationPictoContainer";

class OfferInput extends Component {
	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	onChange() {
		this.props.onChange(this.props.offer.pricing, this.props.offer.negotiated);
	}

	render() {
		const { field = {}, offer = {}, ...props } = this.props;

		const nightCount = get(offer, "pricing.minPrice.n");
		const offerType = get(offer, "pricing.type");
		const price = get(offer, "pricing.minPrice.p");
		const publicPrice = get(offer, "pricing.minPrice.pp");
		const priceIsAvailable = !isNaN(price);
		const nightCountWording = (...chunks) => (
			<span className="offer-input__night-count">{chunks}</span>
		);
		const nightCountWordingParameters = { count: nightCount };

		return (
			<Radio
				showIcon={false}
				field={field}
				id={offerType}
				value={offerType}
				toggle={this.onChange}
				checked={field.value === offerType}
				data-testid={props["data-testid"]}
			>
				<div className="offer-input__wrapper">
					<div className="offer-input__content">
						<div className="offer-input__prices">
							<div className="offer-input__label">
								{get(offer, "pricing.label")}
								{offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION && (
									<TransportationPictoContainer />
								)}
							</div>
							<div className="offer-input__price">
								<AmountContainer
									amount={price}
									prefix={<FormattedMessage id="offer.per.person.from.label" />}
									suffix={
										<FormattedMessage id="general.amount.per.person.suffix.label.short" />
									}
								/>
							</div>
							{offerType === OFFER_TYPES.ACCOMODATION_ONLY && (
								<div className="offer-input__public-price">
									{publicPrice && (
										<AmountContainer
											amount={publicPrice}
											prefix={
												<FormattedMessage id="general.instead.of.price" />
											}
											suffix={
												<FormattedMessage id="general.amount.per.person.suffix.label.short" />
											}
										/>
									)}
								</div>
							)}
							{priceIsAvailable && (
								<FormattedPlural
									value={nightCount}
									one={
										<FormattedMessage
											id="general.nights.count.singular"
											values={nightCountWordingParameters}
										>
											{nightCountWording}
										</FormattedMessage>
									}
									other={
										<FormattedMessage
											id="general.nights.count"
											values={nightCountWordingParameters}
										>
											{nightCountWording}
										</FormattedMessage>
									}
								/>
							)}
						</div>
						<div className="offer-input__cta">
							<Button variant="primary">
								<FormattedMessage id="search.engine.offers.cta.button" />
							</Button>
						</div>
					</div>
					{offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION && (
						<FrequencyFlyersMarketing />
					)}
				</div>
			</Radio>
		);
	}
}

OfferInput.propTypes = {
	field: PropTypes.object,
	offer: PropTypes.object,
	onChange: PropTypes.func,
};

export default OfferInput;
